var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1200 200",
    width: 1200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 122L13.3 112.3C26.7 102.7 53.3 83.3 80 79.7C106.7 76 133.3 88 160 97C186.7 106 213.3 112 240 117.7C266.7 123.3 293.3 128.7 320 122.8C346.7 117 373.3 100 400 87.8C426.7 75.7 453.3 68.3 480 67C506.7 65.7 533.3 70.3 560 83.5C586.7 96.7 613.3 118.3 640 124.7C666.7 131 693.3 122 720 113C746.7 104 773.3 95 800 94.8C826.7 94.7 853.3 103.3 880 111C906.7 118.7 933.3 125.3 960 120.2C986.7 115 1013.3 98 1040 100.2C1066.7 102.3 1093.3 123.7 1120 125.2C1146.7 126.7 1173.3 108.3 1186.7 99.2L1200 90L1200 201L1186.7 201C1173.3 201 1146.7 201 1120 201C1093.3 201 1066.7 201 1040 201C1013.3 201 986.7 201 960 201C933.3 201 906.7 201 880 201C853.3 201 826.7 201 800 201C773.3 201 746.7 201 720 201C693.3 201 666.7 201 640 201C613.3 201 586.7 201 560 201C533.3 201 506.7 201 480 201C453.3 201 426.7 201 400 201C373.3 201 346.7 201 320 201C293.3 201 266.7 201 240 201C213.3 201 186.7 201 160 201C133.3 201 106.7 201 80 201C53.3 201 26.7 201 13.3 201L0 201Z",
    fill: "#fffdf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.9895a3b1d30dd614e27e722ec1d8fda2.svg";
export { ForwardRef as ReactComponent };